import { Button, ButtonGroup, Icon, TextField, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';
import MDTypography from 'components/MDTypography';
import AptaTable from 'examples/AptaTable';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import { hosturl } from 'constants/constant';
import { Delete } from '@mui/icons-material'; // Import DeleteIcon from Material UI
import { COLORS } from 'constants/constant';

function ScratchCards() {
  // State for the scratch card data and form inputs
  const [scratchCards, setScratchCards] = useState([]); // Initialize as an empty array
  const [minAmount, setMinAmount] = useState('');
  const [maxAmount, setMaxAmount] = useState('');
  const [cashback, setCashback] = useState('');
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  // Fetch scratch cards from backend
  useEffect(() => {
    axios.get(`${hosturl}/api/scratchcards`)
      .then(response => {
        setScratchCards(response.data || []); // Ensure it's an empty array if no data
        setLoading(false);
      })
      .catch(error => {
        console.error('There was an error fetching the scratch cards:', error);
        setError('Failed to load scratch cards.');
        setLoading(false);
      });
  }, []);

  // Handle Add Scratch Card
  const handleAddScratchCard = () => {
    const newScratchCard = { minAmount, maxAmount, cashback };
    axios.post(`${hosturl}/api/scratchcards`, newScratchCard)
      .then(response => {
        setScratchCards([...scratchCards, response.data]);
        setMinAmount('');
        setMaxAmount('');
        setCashback('');
      })
      .catch(error => {
        console.error('There was an error adding the scratch card:', error);
      });
  };

  // Handle Delete Scratch Card
  const handleDeleteScratchCard = (id) => {
    axios.delete(`${hosturl}/api/scratchcards/${id}`)
      .then(() => {
        setScratchCards(scratchCards.filter(card => card._id !== id));
      })
      .catch(error => {
        console.error('There was an error deleting the scratch card:', error);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDTypography variant="h5" color="primary">
        Scratch Cards Management
      </MDTypography>

      {/* Form Inputs for adding new scratch card */}
      <div style={{ margin: '20px 0' }}>
        <TextField
          label="Min Amount"
          value={minAmount}
          onChange={(e) => setMinAmount(e.target.value)}
          style={{ marginRight: '20px' }}
        />
        <TextField
          label="Max Amount"
          value={maxAmount}
          onChange={(e) => setMaxAmount(e.target.value)}
          style={{ marginRight: '20px' }}
        />
        <TextField
          label="Cashback"
          value={cashback}
          onChange={(e) => setCashback(e.target.value)}
        />
      </div>

      {/* Add Button */}
      <Button onClick={handleAddScratchCard} style={{ marginBottom: '20px', backgroundColor:COLORS.primary, color:'white' }}>
        Add Scratch Card
      </Button>

      {/* Loading State */}
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : scratchCards.length === 0 ? (
        <Typography>No Scratch Cards Available</Typography>
      ) : (
        // Render Scratch Card Table
        <AptaTable
          columns={['minAmount', 'maxAmount', 'cashback', 'delete']} // List of column names
          rows={scratchCards.map(card => ({
            ...card,
            delete: <Delete onClick={() => handleDeleteScratchCard(card._id)} style={{ cursor: 'pointer', color: 'red' }} /> // Add delete button to each row
          }))} // Add delete button to each row
        />
      )}
    </DashboardLayout>
  );
}

export default ScratchCards;
